/**
 * RefundSlice Sub-Entity Reducers
 * 
 * Handles refund detail and check info updates.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RefundSliceState } from '../state';
import { RefundDetailView, CheckInfoView } from '../../types/refundTypes';

// Helper function to add field to edited fields array without duplicates
const addEditedField = (state: RefundSliceState, fieldName: string) => {
  if (!state.editedFields.includes(fieldName)) {
    state.editedFields.push(fieldName);
  }
  state.isEdited = true;
};

// SessionStorage backup helper
const saveBackup = (state: RefundSliceState) => {
  if (state.currentRefund) {
    try {
      sessionStorage.setItem('refund_backup', JSON.stringify({
        refund: state.currentRefund,
        isEdited: state.isEdited,
        editedFields: state.editedFields
      }));
    } catch (e) {
      // Ignore sessionStorage errors
    }
  }
};

/**
 * Update refund details
 */
export const updateRefundDetails: CaseReducer<RefundSliceState, PayloadAction<Partial<RefundDetailView>>> = (
  state,
  action
) => {
  if (state.currentRefund) {
    state.currentRefund.refundDetail = { 
      ...state.currentRefund.refundDetail, 
      ...action.payload 
    };
    addEditedField(state, 'refundDetail');
    saveBackup(state);
  }
};

/**
 * Update check information
 */
export const updateCheckInfo: CaseReducer<RefundSliceState, PayloadAction<Partial<CheckInfoView>>> = (
  state,
  action
) => {
  if (state.currentRefund) {
    state.currentRefund.checkInfo = { 
      ...state.currentRefund.checkInfo, 
      ...action.payload 
    };
    addEditedField(state, 'checkInfo');
    saveBackup(state);
  }
};
